module.exports = __webpack_public_path__ + "static/media/elo_promoters_logos_desktop.05f5335c.webp";